import { Typography } from "@mui/material";
import { TypographyFormElement } from "../../../../types";

export const TypographyInlineDisplay = ({
  ...props
}: {
  element: TypographyFormElement;
}) => {
  return (
    <Typography
      variant={props.element.variant || "body1"}
      textAlign={props.element.textAlign || "left"}
      sx={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}
    >
      {props.element.label}
    </Typography>
  );
};
